<template>
	<div class="tpl login-wrap">
		<mt-header title="" fixed>
		  <router-link :to="{name:'home'}" slot="left">
		    <mt-button><img src="../../assets/img/mine/sl_signin_ic_closed.png"/></mt-button>
		  </router-link>
		  <mt-button  slot="right" @click="toRegister">注册</mt-button>
		</mt-header>
		<login-pass v-if="!showCode" @showCodeLogin="showCodeLogin"></login-pass>
		<login-code v-if="showCode"></login-code>
	</div>
</template>

<script>
	import LoginPass from "./LoginPass"
	import LoginCode from "./LoginCode"
	
	export default{
		name:"login",
		components:{
			LoginPass,
			LoginCode
		},
		data(){
			return{
				uid:"",
				showCode:0,
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);
			
		},
		methods:{
			toRegister(){
				this.$router.push({
					name:"register"
				})
			},
			showCodeLogin(){
				this.showCode = 1;
			}
		}
	}
</script>

<style scoped>
	.mint-header{
		border-bottom: 0 !important;
	}
	.login-wrap{
		width: 100vw;
		height: 100vh;
		background: #fff;
		padding-top: 2.5rem;
	}
	>>>.mint-button-text{
		color: #282828;
	}
	.mint-button-text img{
		width: 1.2rem;
		display: block;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/Login.vue